import React from 'react';
import styled from 'styled-components';

const ContactUs = () => {
  return (
    <ContactContainer>
      <h2>Contact Us</h2>
      <ContactInfo>
      <p><strong>Business Name : </strong>Keybyte Fresh and Services Pvt Ltd</p>
        <p><strong>Contact:</strong> 9599534149</p>
        <p><strong>Address:</strong> Kudiary, Jatni, Khurdha, Odisha 752050</p>
        <p><strong>Email:</strong></p>
        <ul>
          <li>biswojit@keybytesystems.com</li>
          <li>pronab@keybytesystems.com</li>
        </ul>
        <p>
          <strong>Services:</strong> Providing food delivery service on web and mobile app platform.
        </p>
      </ContactInfo>
    </ContactContainer>
  );
};

// Styled Components
const ContactContainer = styled.div`
  max-width: 800px;
  margin: 50px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const ContactInfo = styled.div`
  margin-top: 20px;
  text-align: left;
  font-size: 1rem;
  line-height: 1.6;

  p {
    margin: 10px 0;
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      margin: 5px 0;
    }
  }

  strong {
    color: #333;
  }
`;

export default ContactUs;

